import { PageCardAccountActions } from './Actions';
import { PageCardAccountApiResponse } from './ApiResponse';
import { PageCardAccount } from './CardAccount';
import { PageCardAccountCards } from './Cards';
import { PageCardAccountEvents } from './Events';
import { PageCardAccountInformation } from './Information';
import { PageCardAccountsOverview } from './Overview';

export { PageCardAccountsOverview } from './Overview';

export const CARD_ACCOUNTS = {
  CardAccounts: PageCardAccountsOverview,
  CardAccountSection: PageCardAccount,
  CardAccountInformation: PageCardAccountInformation,
  CardAccountCards: PageCardAccountCards,
  CardAccountEvents: PageCardAccountEvents,
  CardAccountActions: PageCardAccountActions,
  CardAccountApiResponse: PageCardAccountApiResponse,
} as const;
